export const version = '0.761.0'
export const chameleonWebVersion = '9.2.0'
export const chameleonCoreVersion = '7.7.0'
